var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMageEmail({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3183 2.91602H5.56832C3.72737 2.91602 2.23499 4.4084 2.23499 6.24935V13.7494C2.23499 15.5903 3.72737 17.0827 5.56832 17.0827H14.3183C16.1593 17.0827 17.6517 15.5903 17.6517 13.7494V6.24935C17.6517 4.4084 16.1593 2.91602 14.3183 2.91602Z",
    stroke: "#5070DE",
    strokeWidth: 1.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.27417 6.32422L8.27834 9.76589C8.78148 10.0578 9.35287 10.2116 9.93459 10.2116C10.5163 10.2116 11.0877 10.0578 11.5908 9.76589L17.6117 6.32422",
    stroke: "#5070DE",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageEmail);
export default __webpack_public_path__ + "static/media/mage_email.0089be3e4e3733e3b7ccf05cb4f37819.svg";
export { ForwardRef as ReactComponent };